<template>
  <div class="thank-you-step">
    <div class="thank-you-content">
      <!-- Title -->
      <div class="title-section">
        <h2 class="step-title">{{ step.title }}</h2>
        <p v-if="step.subtitle" class="step-subtitle">{{ step.subtitle }}</p>
      </div>

      <!-- Avatar -->
      <div class="avatar-container">
        <img :src="avatarImage" alt="AI Assistant" class="ai-avatar" />
      </div>

      <!-- Action Button -->
      <div class="action-section">
        <custom-button
          @click="nextStep"
          class="next-button"
          rounded
        >
          Продолжить
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CustomButton from '@/components/UI/CustomButtom/CustomButton.vue'
import { useTasteClarificationModal } from '@/features/taste/store'
import type { TasteStep } from '@/features/taste/types/taste-config'

interface Props {
  step: TasteStep & { type: 'thank_you' }
}

const props = defineProps<Props>()
const tasteStore = useTasteClarificationModal()

const avatarImage = '/img/survey-avatar.png'

function nextStep() {
  tasteStore.nextStep()
}
</script>

<style scoped>
.thank-you-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 20px;
  text-align: center;
  height: 100%;
}

.thank-you-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 500px;
  height: 100%;
  width: 100%;
}

.avatar-container {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.ai-avatar {
  width: 330px;
  height: 330px;
  border-radius: 50%;
  object-fit: cover;
}

.title-section {
  margin-bottom: 32px;
}

.step-title {
  font-size: 28px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.step-subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.action-section {
  margin-bottom: 24px;
}

.results-button {
  display: flex;
  cursor: pointer;
  transition: all 0.3s ease;
}

.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #666;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007aff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-section p {
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

@media (max-width: 480px) {
  .step-title {
    font-size: 24px;
  }

  .results-button {
    width: 100%;
    justify-content: center;
  }
}
</style>

